(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ccustomProgressBarLiquid"] && !Shopify.designMode) return;
  try {
    const customProgressBar = document.getElementById('customProgressBar');
  document.documentElement.style.setProperty('--progressBarWidth', customProgressBar.dataset.customProgressBarPercentage+'%');
  //const customHeaderCartTotalPrice = document.getElementById('customHeaderCartTotalPrice');
  //customHeaderCartTotalPrice.dataset.customOldProgressBarPercentage = customProgressBar.dataset.customProgressBarPercentage;
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["price"] && !Shopify.designMode) return;
  try {
    const customPriceCalendarIconContainer = document.getElementById('customPriceCalendarIconContainer')
  if (customPriceCalendarIconContainer)
    document.documentElement.style.setProperty('--price30dayAmount', customPriceCalendarIconContainer.dataset.productPrice);
  } catch(e) { console.error(e); }
})();

})();
